import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { EmploymentSection } from '../components/EmploymentSection';
export function AboutPage() {
  return <main className="bg-light min-h-screen" data-id="element-392">
      <PageBanner title="About Us" subtitle="Learn more about our mission, our team, and our commitment to your care." breadcrumbs={[{
      label: 'About Us',
      path: '/about'
    }]} data-id="element-393" />
      <AboutSection data-id="element-394" />
      <WhyChooseUs data-id="element-395" />
      <EmploymentSection className="bg-light" data-id="element-396" />
    </main>;
}